import React from 'react';
import '../portfolioProjectAlpineSport/portfolioProjectAlpineSport.css';

import BlueStroke from '../../assets/portfolio/blue-stroke.svg';
import AlpineHero from '../../assets/portfolio/alpine-hero.png';
import AlpineDesign from '../../assets/portfolio/alpine-design.png';
import AlpineLogoDesign from '../../assets/portfolio/alpine-logo-design.png';
import AlpineFinalDesign from '../../assets/portfolio/alpine-final-design.png';
import AlpineWeatherApp from '../../assets/portfolio/alpine-weather-app.png';

function PortfolioProjectAlpineSport() {
  return (
    <div className="project-container">
      <img
        className="stroke-upper"
        src={BlueStroke}
        alt="blue brush stroke"
      />

      <section className='hero-title'>
        <img
          className='project-hero'
          src={AlpineHero}
          alt="Alpine hero"
        />

        <aside className="hero-text">
          <h2>Alpine Sport</h2>
          <h3>
            <a href="https://alpinesport.se/" target="_blank" rel="noopener noreferrer">
              alpinesport.se
            </a>
          </h3>
        </aside>
      </section>

      <section className='project-section-width project-background-movzblue'>
        <article className='project-article-maxwidth'>
          <aside>
            <h2 className='project-h2'>The Job</h2>
            <h3 className='project-h3'>UX | FRONTEND | SEO | WEB CONTENT</h3>
            <ul className='list-maxwidth job-list'>
              <li>Identify target users & personas.</li>
              <li>Identify Alpine Sports needs and goals for the website.</li>
              <li>Create a brand platform & design ideas in Figma.</li>
              <li>Together with the product owner, decide on which design to go forward with.</li>
              <li>Code up the website.</li>
              <li>Add analytics, search engine optimisation and connect to AWS Amplify for publishing.</li>
              <li>Time scale: ongoing.</li>
            </ul>
          </aside>
          <aside className='margin-bottom extra-padding-bottom'>
            <h2 className='project-h2'>Role</h2>
            <p className='project-p'>
              Entire product design from idea, through testing, to webdesign, web content, SEO optimisation and published product. Ongoing with site maintenance and development.
            </p>
          </aside>
        </article>
      </section>

      <section className='project-section-width project-background-movzwhite extra-margin-bottom'>
        <article className='project-article-maxwidth extra-padding-top extra-padding-bottom'>
          <h2 className='project-h2 dark-text'>Design Development</h2>
          <p className='project-p dark-text'>
            The first main challenge after creating initial design suggestions was to develop a new logotype for Alpine Sport. The main need was to have a simple design that could be used both on digital platforms and also used for branding purposes. <br /><br />It was important to be able to associate the design with alpine skiing and Alpine Sport. That was done through using the colour grading system for ski runs used in ski resorts here in Sweden and by using clean, slightly styled text.
          </p>
          <img className='designDev-img' src={AlpineDesign} alt="design ideas" />
          <img className='designDev-img' src={AlpineLogoDesign} alt="logo design" />
          <p className='project-p dark-text'>
            Choosing a design idea to develop was no easy task. Being relativelty new to the bransch it was important to be able to quickly provide relevant information to potential customers and easily book the correct type of service required. Another important aspect was to give the site a quality professional feel in order to inspire confidence from customers.
            <br /><br />
            In the design process testing was done on potential users to help find the design to develop. This was a simple process where potential users were given a selection of 6 different designs and were asked to choose their favourite and motivate why.
          </p>
        </article>
      </section>

      <section className='project-section-width project-background-movzblue'>
        <article className='project-article-maxwidth'>
          <h2 className='project-h2'>Final Design</h2>
          <p className='project-p'>
            The final design concept including suggestions for how each page may look was then produced. Not everything could be designed at this point as all content was not ready. The published site is now a version 2.0 and is still under continual development. <br /><br />
            In version 2.0 the customer can easily find information about services and make a booking within just a couple of clicks. There is clear information about where the business is located and how the booking process works, as well as background information about the owner and service technician.
          </p>
          <img className='designDev-img' src={AlpineFinalDesign} alt="final design concept" />
          <p className='project-p'>
            During the design process I felt that there needed to be some other sort of added value in order to try and encourage users to return to the page regularly. The choice fell on a simple weather app designed to give a 7 day forecast for skiers. By making API calls to SMHI’s open source weather data it was simple to produce weather data for specific latitude longitudes within Scandinavia so the users can see weather data for their favourites resorts.
          </p>
          <img className='designDev-img' src={AlpineWeatherApp} alt="weather app design" />
          <h2 className='project-h2'>Conclusion</h2>
          <p className='project-p margin-bottom'>
            I think this project went very well considering the very limited timeframe given for development. This was originally a final thesis I produced for a frontend developer course i undertook which had a time limit of just three weeks to complete the design, coding and publishing processes. However, being my own business i already had a clear idea of what i wanted and roughly how I would do it.
            <br /><br />
            The result is a site which can easily be found using search engines and can produce measurable statistics for further SEO development. It was a steep learning curve for me as we had not studied SEO or publishing as part of our course and I felt that this was very important to learn. Of course there were mistakes and aha moments. The main aha, was discovering that react router dom isnt particularly good for SEO optimisation, instead I should perhaps have used Next.js, but we had not learnt how to use that and considering the short time frame for the project and since I had already coded most of the site when I realised this, there was no point changing. This resulted in more work in order to SEO optimise the site however.
            <br /><br />
            To winter 25/26 there will be a number of design changes and add ons. The main change will be in the booking system where i will remove the calendar in favour of a simple contact form. Another area to develop is in content such as how-to guides and tips and tricks. Also I will be developing the weather app further since it needs more refining.
          </p>
        </article>
      </section>

      <img
        className="stroke-lower"
        src={BlueStroke}
        alt="blue brush stroke"
      />
    </div>
  )
}

export default PortfolioProjectAlpineSport;

